export interface ParsedSpotRow {
    holder: string;
    email: string;
    planta: string;
    numero: string;
    maxAssignments?: number;
}

export interface ParseResult {
    rows: ParsedSpotRow[];
    skipped: number; // rows we couldn't interpret
}

function parseCsvRows(text: string): string[][] {
    const rows: string[][] = [];
    const source = text.replace(/^﻿/, ''); // strip BOM if present
    let i = 0;
    let field = '';
    let row: string[] = [];
    let inQuotes = false;

    while (i < source.length) {
        const c = source[i];
        if (inQuotes) {
            if (c === '"') {
                if (source[i + 1] === '"') {
                    field += '"';
                    i += 2;
                    continue;
                }
                inQuotes = false;
                i++;
                continue;
            }
            field += c;
            i++;
        } else {
            if (c === '"') {
                inQuotes = true;
                i++;
                continue;
            }
            if (c === ',' || c === ';') {
                row.push(field);
                field = '';
                i++;
                continue;
            }
            if (c === '\r') {
                i++;
                continue;
            }
            if (c === '\n') {
                row.push(field);
                rows.push(row);
                row = [];
                field = '';
                i++;
                continue;
            }
            field += c;
            i++;
        }
    }
    // Flush last field/row
    if (field.length > 0 || row.length > 0) {
        row.push(field);
        rows.push(row);
    }

    return rows
        .map((r) => r.map((f) => f.trim()))
        .filter((r) => r.some((f) => f.length > 0));
}

function looksLikeHeader(row: string[]): boolean {
    return row.some((c) =>
        /^(holder|titular|email|correo|planta|plaza|numero|n[uú]mero|floor|spot|max|m[aá]ximo|maxusuarios|max_assignments)s?$/i.test(
            c,
        ),
    );
}

function parseMax(value: string | undefined): number | undefined {
    if (value === undefined || value === '') return undefined;
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n >= 0 ? n : undefined;
}

export function parseParkingCsv(text: string): ParseResult {
    const rawRows = parseCsvRows(text);
    if (rawRows.length === 0) return { rows: [], skipped: 0 };

    const startIdx = looksLikeHeader(rawRows[0]) ? 1 : 0;
    const dataRows = rawRows.slice(startIdx);

    const parsed: ParsedSpotRow[] = [];
    let skipped = 0;

    // One row per spot: holder, email, planta, numero, [max_usuarios]
    for (const row of dataRows) {
        if (row.length < 4) {
            skipped++;
            continue;
        }
        const [holder, email, planta, numero, maxCol] = row;
        if (!planta || !numero) {
            skipped++;
            continue;
        }
        parsed.push({
            holder,
            email,
            planta: planta.trim(),
            numero: numero.trim(),
            maxAssignments: parseMax(maxCol),
        });
    }

    return { rows: parsed, skipped };
}
